
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DettaglioAdempimento } from '../models/dettaglio-adempimento';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { BaseForm } from './base-Form';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { DettaglioAdempimentoAdapter } from '../components/fascicolo/dettaglio-adempimenti/dettaglio-adempimento-adapter';
import { TipoEsito } from '../models/tipologiche/tipo-esito';
import { FormValidationService } from '../services/form-validation.service';

export abstract class DettaglioAdempimentoForm extends BaseForm {

  request: DettaglioAdempimento;
  fascicolo: FascicoloFull;
  dettaglioForm: FormGroup;
  tipoEsitiOptions: TipoEsito[] = [];


  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService,
              protected formValidationService: FormValidationService){
    super();
  }

 initRequest() {
   
  }

  createForm() {
    this.request = new DettaglioAdempimentoAdapter(this.getDettaglioAdempimento()).dettaglioAdempimento;
    this.dettaglioForm = this.campiForm.group({
      tipoEsito: [this.request.tipoEsito, Validators.required],
      esitoDescrizione: [this.request.esitoDescrizione, Validators.required],
      numeroEsito: [this.request.numeroEsito],
      annoEsito: [this.request.annoEsito,Validators.compose([this.formValidationService.anno])],        
      dataPubblicazione: [this.request.dataPubblicazione,Validators.required],  
    });
  }
  
  populateSelect() {
    if (this.tipoEsitiOptions.length === 0) {
      this.helpers.getTipiEsiti().subscribe(response => {
        this.tipoEsitiOptions = response.filter(el => el.label.toUpperCase() != 'DELIBERAZIONE CDA' && el.label.toUpperCase() != 'DELIBERAZIONE UFFICIO')
      });
    }  
  }
  
  update() {
    this.getRequest(this.request);
  }

  abstract getDettaglioAdempimento(): DettaglioAdempimento;
  abstract getRequest(request: DettaglioAdempimento);


}